import React from 'react';
import Layout from '../../../components/Layout';
import Page from '../../../components/Page';
import fetch from '../../../core/fetch';
import { isUsableSpanishLegalPage } from '../../../helpers/staticPageContent';
import spanishTerms from '../../../content/termsPrivacy.es';

const query = `query getEditStaticPage ($id: Int!) {
  getEditStaticPage (id: $id) {
      id
      pageName
      content
      metaTitle
      metaDescription
      createdAt
  }
}`;

export default async function action() {
  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: query,
      variables: { id: 4 },
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (isUsableSpanishLegalPage(data && data.getEditStaticPage)) {
    return {
      title: data.getEditStaticPage.metaTitle,
      description: data.getEditStaticPage.metaDescription,
      component: <Layout><Page html={data.getEditStaticPage.content} title={data.getEditStaticPage.metaTitle} /></Layout>,
    };

  } else {
    return {
      title: spanishTerms.title,
      description: spanishTerms.description,
      component: <Layout><Page html={spanishTerms.html} title={spanishTerms.title} /></Layout>,
    };
  }
}
